import { LanguageType } from "@/custom-types"
import { useUserLanguage } from "@/customHooks"
import { OwnerContractLeaseTypeOption } from "@/graphql/generated"

type OwnerContractLeaseTypePillProps = {
  type: OwnerContractLeaseTypeOption
}

type OptionConfig = {
  text: string
  className: string
}

const STYLES = {
  style1: "text-[#4a9462] bg-[#d2f3dc]",
  style2: "text-[#2f7ebd] bg-[#d6ecff]",
  style3: "text-[#7a5af8] bg-[#eee9ff]",
} as const

const OPTION_MAPPING: Record<LanguageType, Record<OwnerContractLeaseTypeOption, OptionConfig>> = {
  en: {
    ASSURED_PAYMENT: {
      text: "Assured Payment",
      className: STYLES.style2,
    },
    LEASE_SUBLET: {
      text: "Lease Sublet",
      className: STYLES.style3,
    },
    OCCUPATION_MANAGMENT: {
      text: "Occupation Management",
      className: STYLES.style1,
    },
  },
  es: {
    ASSURED_PAYMENT: {
      text: "Renta Asegurada",
      className: STYLES.style2,
    },
    LEASE_SUBLET: {
      text: "Subarriendo",
      className: STYLES.style3,
    },
    OCCUPATION_MANAGMENT: {
      text: "Gestión de Ocupación",
      className: STYLES.style1,
    },
  },
}

export const OwnerContractLeaseTypePill = ({ type }: OwnerContractLeaseTypePillProps) => {
  const language = useUserLanguage()

  const config =
    OPTION_MAPPING[language]?.[type] ??
    { text: type, className: STYLES }

  return (
    <div
      className={`inline-flex items-center justify-center px-3 py-1 rounded-full text-xs font-semibold ${config.className}`}
    >
      {config.text}
    </div>
  )
}